import React, { useState } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { wrapFunctionalComponent } from 'utils/framework';
import { Link, Text } from 'components/ui';
import SentimentModal from 'components/ProductPage/RatingsAndReviews/HighlyRatedFor/SentimentModal/';
import UI from 'utils/UI';
import localeUtils from 'utils/LanguageLocale';
import { productSelector } from 'selectors/page/product/productSelector';
import { isGenAIPRSEnabledSelector } from 'ai/selectors/killSwitches/isGenAIPRSEnabledSelector';
import productPageSOTBindings from 'analytics/bindingMethods/pages/productPage/productPageSOTBindings';
import productActions from 'actions/ProductActions';
import * as pdpAnalytics from 'analytics/productPage/pdpAnalytics';
import highlightedModalLoad from 'analytics/bindings/pages/all/highlightedModalLoad';
import HighlyRatedForEN from 'components/ProductPage/RatingsAndReviews/HighlyRatedFor/locales/HighlyRatedFor_en_US';
import HighlyRatedForFR from 'components/ProductPage/RatingsAndReviews/HighlyRatedFor/locales/HighlyRatedFor_fr_CA';

const getText = localeUtils.getLocalisedDataFromResource(HighlyRatedForEN, HighlyRatedForFR);

const MAX_PROS = 5;
const LIMIT_OF_REVIEWS = 6;
const SEPH_SENTIMENT_SOURCE = 'seph_sentiment';
const RATINGS_REVIEWS_ANCHOR = 'ratings-reviews-container';

const HighlyRatedFor = ({ onSentimentApply, showPDPTopOfPageRedesign }) => {
    const dispatch = useDispatch();
    const product = useSelector(productSelector, shallowEqual);
    const isGenAIPRSEnabled = useSelector(isGenAIPRSEnabledSelector);
    const localization = {
        linkLead: getText('linkLead'),
        linkLeadRedesign: getText('linkLeadRedesign')
    };

    const [selectedId, setSelectedId] = useState(null); // eslint-disable-line no-unused-vars
    const [isModalOpen, setIsModalOpen] = useState(false);

    const closeModal = () => setIsModalOpen(false);

    const filterProSentiments = sentiments => {
        const pros = sentiments.filter(sentiment => sentiment.type === 'pros');

        return pros.slice(0, MAX_PROS);
    };

    const fireAnalytics = () => {
        productPageSOTBindings.highlyRatedForClick();
        pdpAnalytics.trackPageLoad({ bindingMethods: [highlightedModalLoad] });
    };

    const handleSentimentClick = (item, index) => {
        fireAnalytics();

        if (isGenAIPRSEnabled) {
            dispatch(
                productActions.loadHighlightedReviews({
                    sentiment: item.sentiment,
                    type: item.type,
                    productId: product?.productDetails?.productId,
                    limit: LIMIT_OF_REVIEWS,
                    page: 0,
                    language: localeUtils.getCurrentLanguage(),
                    sentimentSource: SEPH_SENTIMENT_SOURCE
                })
            );
            UI.scrollTo({ elementId: RATINGS_REVIEWS_ANCHOR });
        } else {
            setSelectedId(index);
            setIsModalOpen(true);
        }
    };

    const createList = items => {
        const length = items.length;

        return items.map((item, index) => {
            const isLast = index + 1 === length || index + 1 === MAX_PROS;

            return (
                <React.Fragment key={item.sentiment}>
                    <Link
                        color='blue'
                        underline={!showPDPTopOfPageRedesign}
                        padding={1}
                        margin={-1}
                        key={item.sentiment}
                        onClick={() => handleSentimentClick(item, index)}
                        children={item.sentiment}
                    />
                    {isLast ? ' ' : ',  '}
                </React.Fragment>
            );
        });
    };

    const { sentiments = [] } = product;
    const proSentiments = filterProSentiments(sentiments);
    const prosLinkList = createList(proSentiments);
    const productId = product?.productDetails?.productId;
    const lead = showPDPTopOfPageRedesign ? localization.linkLeadRedesign : localization.linkLead;

    return (
        <>
            <SentimentModal
                closeModal={closeModal}
                proSentiments={proSentiments}
                isModalOpen={isModalOpen}
                productId={productId}
                onSentimentApply={onSentimentApply}
            />
            <Text
                is='p'
                fontSize={showPDPTopOfPageRedesign ? ['sm-bg', 'base-bg'] : 'sm-bg'}
            >
                {lead} {prosLinkList}
            </Text>
        </>
    );
};

export default wrapFunctionalComponent(HighlyRatedFor, 'HighlyRatedFor');
